import { HStack, Box } from '@chakra-ui/react'

import { ElementProps } from '../../GenericElement/GenericElement'

const Element: React.FC<ElementProps> = ({ item, hasErrors }) => {
  const heading = item.text.heading
  const description = item.text.description
  const empty = !heading && !description
  return (
    <HStack w="full" gap={4} pl={3} justifyContent="stretch">
      <Box flex="1 1 min-content">
        {(heading || empty) && (
          <Box
            as="h5"
            noOfLines={description ? 1 : 2}
            className="thick"
            color={empty ? 'graphite' : hasErrors ? 'danger' : 'onyx'}
          >
            {heading ?? `Empty text`}
          </Box>
        )}
        {description && (
          <Box
            noOfLines={heading ? 1 : 2}
            className="body-small"
            color={hasErrors ? 'danger' : 'onyx'}
          >
            {description}
          </Box>
        )}
      </Box>
    </HStack>
  )
}

export default Element
